import React, { useState, useEffect, useRef } from 'react';

function TopPromoBar({ appName }) {
  const [currentSlide, setCurrentSlide] = useState(0);
  const intervalRef = useRef(null);

  const items = [
    {
      icon: '🚚',
      title: 'Safe & Secure Shipping',
      subtitle: 'Call for same day delivery'
    },
    {
      icon: '✓',
      title: 'Delivery guarantee',
      subtitle: '7 days return policy for any issues'
    },
    {
      icon: '📱',
      title: `Get the ${appName} App`,
      subtitle: null
    }
  ];

  // Group items into slides: first slide has shipping + delivery, second has app
  const slides = [
    [items[0], items[1]], // Slide 0: Free shipping + Delivery guarantee
    [items[2]] // Slide 1: Get the App
  ];

  // Auto-slide carousel on mobile
  useEffect(() => {
    // Only run carousel on mobile (below sm breakpoint)
    const checkMobile = () => window.innerWidth < 640;
    
    if (checkMobile()) {
      intervalRef.current = setInterval(() => {
        setCurrentSlide((prev) => (prev + 1) % slides.length);
      }, 3000);
    }

    return () => {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
      }
    };
  }, [slides.length]);

  return (
    <div className="fixed top-0 left-0 right-0 bg-gradient-to-r from-secondary to-primary text-white py-1.5 sm:py-2 text-xs sm:text-sm w-full max-w-full overflow-x-hidden z-[60]">
      <div className="max-w-screen-2xl mx-auto px-4 sm:px-6 lg:px-8 w-full">
        {/* Desktop View - Original Layout */}
        <div className="hidden sm:flex flex-wrap justify-center sm:justify-around items-center gap-4 sm:gap-6 lg:gap-8">
          {items.map((item, index) => (
            <div key={index} className="flex items-center gap-1.5 sm:gap-2">
              <span className="text-lg sm:text-xl">{item.icon}</span>
              <div className="flex flex-col leading-tight">
                <strong className="text-yellow-400 font-semibold drop-shadow-sm text-xs sm:text-sm">{item.title}</strong>
                {item.subtitle && (
                  <small className="text-[10px] sm:text-xs opacity-90">{item.subtitle}</small>
                )}
              </div>
            </div>
          ))}
        </div>

        {/* Mobile View - Carousel */}
        <div className="sm:hidden relative overflow-hidden">
          <div
            className="flex transition-transform duration-500 ease-in-out"
            style={{ transform: `translateX(-${currentSlide * 100}%)` }}
          >
            {slides.map((slideItems, slideIndex) => (
              <div
                key={slideIndex}
                className="min-w-full flex items-center justify-center gap-12 px-4 h-full"
              >
                {slideItems.map((item, itemIndex) => (
                  <div
                    key={itemIndex}
                    className="flex items-center gap-1.5 sm:gap-2 whitespace-nowrap"
                  >
                    <span className="text-lg sm:text-xl flex-shrink-0">{item.icon}</span>
                    <div className="flex flex-col leading-none">
                      <strong className="text-yellow-400 font-semibold drop-shadow-sm text-xs sm:text-sm whitespace-nowrap">{item.title}</strong>
                      {item.subtitle && (
                        <small className="text-[10px] sm:text-xs opacity-90 whitespace-nowrap">{item.subtitle}</small>
                      )}
                    </div>
                  </div>
                ))}
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}

export default TopPromoBar;
